import { request } from "../helper/axios_helper";

const BASE = "/api/auth/dblib/mapping";

export const getMappingNames  = ()     => request("GET",  `${BASE}/names`);
export const getMappingByName = (name) => request("GET",  `${BASE}/get/${name}`);
export const addMapping       = (data) => request("POST", `${BASE}/add`, data);
